<template lang="pug">
    table.memorize-table(
        :class="{\
            'memorize-table--small-border': numbers.length > 6,\
        }"
    )
        tbody(v-if="numbers.length")
            tr.memorize-table__row(
                v-for='(row, rowIndex) in numbers',
                :key='rowIndex'
            )
                td.memorize-table__cell(
                    v-for='(cell, cellIndex) in row',
                    :key='cellIndex'
                    :style="itemStyle"
                )
                    .memorize-table__cell_preview(v-if="isShown")
                        span
                            | {{ cell }}
                    .memorize-table__press-item(v-if="!isShown" @click='handleClick(cell)')

</template>

<script>
    export default {
        components: {},
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            numbers: {
                type: Array,
                default: null,
            },
            isShown: {
                type: Boolean,
                default: false,
            },
            displaySpeed: {
                type: Number,
                default: 0,
            },
        },
        mounted() {
            window.addEventListener('resize', this.calculateSizeForMemorizeTable);
            this.calculateSizeForMemorizeTable();
        },
        data() {
            return {
                itemSize: 0,
                itemLineHeight: 73,
            };
        },
        computed: {
            itemStyle() {
                return {
                    height: this.itemSize + 'px',
                    width: this.itemSize + 'px',
                    'font-size': (this.itemLineHeight - 9) * this.fontCoefficient + 'px',
                    'line-height': this.itemLineHeight * this.fontCoefficient + 'px',
                };
            },
            fontCoefficient() {
                return this.itemSize / this.itemLineHeight;
            },
        },
        methods: {
            handleClick(num) {
                if (this.isShown) {
                    return;
                }
                let selectedCell = event.target;
                this.$emit('handleClick', selectedCell, num);
            },
            calculateSizeForMemorizeTable() {
                this.itemSize = 0;
                this.$nextTick(() => {
                    let memorizeTable = document.querySelector('.memorize-table');
                    let items = Array.from(document.querySelectorAll('.memorize-table__cell'));
                    const isSafari =
                        /constructor/i.test(window.HTMLElement) ||
                        (function(p) {
                            return p.toString() === '[object SafariRemoteNotification]';
                        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    const newDimensionValue = value => (isSafari ? value * 0.88 : value);

                    const rowsAmount = this.numbers.length;
                    const columnsAmount = this.numbers[0].length;
                    const heightCoefficient = rowsAmount / Math.max(rowsAmount, columnsAmount);
                    const widthCoefficient = columnsAmount / Math.max(rowsAmount, columnsAmount);

                    let tempTableSize;
                    if (isSafari) {
                        const playBoxContainer = document.querySelector('.play-box');
                        tempTableSize = Math.min(
                            playBoxContainer.clientWidth / widthCoefficient,
                            playBoxContainer.clientHeight / heightCoefficient
                        );
                    } else {
                        tempTableSize = Math.min(
                            memorizeTable.clientWidth / widthCoefficient,
                            memorizeTable.clientHeight / heightCoefficient
                        );
                    }
                    memorizeTable.style.height = newDimensionValue(tempTableSize) * heightCoefficient + 'px';
                    memorizeTable.style.width = newDimensionValue(tempTableSize) * widthCoefficient + 'px';
                    this.itemSize = newDimensionValue(items[0].clientWidth);
                });
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateSizeForMemorizeTable);
        },
    };
</script>

<style scoped lang="scss">
    .memorize-table {
        width: 90%;
        height: 90%;
        margin: 0 auto;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
    }

    .memorize-table--disabled .memorize-table__press-item {
        pointer-events: none;
        cursor: auto;
        &:hover {
            background-color: transparent;
        }
    }

    .memorize-table__cell {
        text-align: center;
        vertical-align: middle;
        background: $hsl-color-gray-92;
        font-size: 62px;
        line-height: 73px;
    }

    .memorize-table__cell_preview {
        line-height: 0;
        width: 80%;
        height: 80%;
        @include media($lg) {
            font-size: 62px;
            width: 90%;
            height: 90%;
        }
        font-size: 33px;
        margin: auto;
        display: flex;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-10;
        justify-content: center;
        color: $hsl-color-green-58;
        background-color: $x-color-white;
    }
    .memorize-table__press-item {
        line-height: 0;
        width: 80%;
        height: 80%;
        @include media($lg) {
            font-size: 62px;
            width: 90%;
            height: 90%;
        }
        font-size: 40px;
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-12;
        box-shadow: 0 0 2px $hsl-color-gray-74;
        background-color: $x-color-white;
        justify-content: center;
        color: $hsl-color-green-58;
        transition: background-color 0.1s;
        &:hover {
            background-color: rgba($hsl-color-green-58, 0.3);
        }
    }

    .memorize-table__press-item_green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;
        &:hover {
            background-color: $hsl-color-green-58;
        }
    }

    .memorize-table__press-item_white {
        transition: none;
        background-color: $hsl-color-gray-97;
        &:hover {
            background-color: $hsl-color-gray-97;
        }
    }
    @import '@/assets/sass/animations/shake.scss';
</style>
